import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBarcode: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBarcode"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4H8V6H4V10H2V4ZM16 4H22V10H20V6H16V4ZM9 9V15H7V9H9ZM13 9V13H11V9H13ZM17 9V15H15V9H17ZM4 14V18H8V20H2V14H4ZM22 14V20H16V18H20V14H22Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBarcode;
